<template>
    <v-container>
        <v-row>
            <v-col cols=12 md=6>
                <v-row>
                    <v-col cols=12>
                        <h3 class="primary--text headline font-weight-black">Leerwerktrajecten overzicht</h3>
                        <p style="line-height: 2;">
                            De arbeidsmarkt verandert razendsnel. Beroepen verdwijnen, nieuwe komen eraan. Werk dat je
                            een leven lang blijft doen, bestaat niet meer. Scholing en ontwikkeling is belangrijker dan
                            ooit. Werknemers en werkzoekenden moeten zichzelf continu blijven ontwikkelen en werkgevers
                            moeten ervoor zorgen dat hun medewerkers zich hun leven lang blijven ontwikkelen. Investeren
                            in kennis is noodzakelijk om de veranderingen op de arbeidsmarkt bij te houden.
                        </p>
                        <p style="line-height: 2;">
                            Met de onderstaande filters ziet u in één oogopslag welke leerwerktrajecten beschikbaar zijn
                            binnen de arbeidsmarktregio.
                        </p>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols=12>
                <Search
                    :base-query="query"
                    :fields="[
                        'SearchQueryFilter',
                        // 'TileFilter',
                        'ReachFilter',
                        'RegionFilter',
                        'TownshipFilter',
                        'AgeFilter',
                        // 'EmploymentTypeFilter',
                        'TargetGroupFilter',
                        'TargetGroupRegisterFilter',
                        'SectorFilter',
                    ]"
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<style lang="scss" scoped>
    .container {
        max-width: 100%;
    }
</style>

<script>
    import Search from '@/components/search/Search';
    import InstrumentsES from '@/services/InstrumentsES';

    export default {
        name: 'LeerwerktrajectInstrumentsSearch',
        components: {
            Search
        },
        data() {
            return {
                query: () => InstrumentsES.getQuery({
                    query: {
                        bool: {
                            filter: [
                                { "term": { "is_leerwerktraject": true } },
                            ]
                        }
                    }
                }),
            }
        },
    }
</script>
